module.exports = __webpack_public_path__ + "static/img/Laptop.a4014ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hiw/Laptop.png
// module id = 655
// module chunks = 1